<template>
    <div v-if="viewModel.theme" class="d-flex">

        <div style="min-height: 500px; width: 200px; background-color: #fcfafa;">

            <div class="my-2 mx-1">
                <button class="btn btn-light btn-sm" @click="onNewClick" data-bs-toggle="tooltip" data-placement="top" data-bs-title="new theme">
                    <i class="fas fa-plus text-primary"></i>
                </button>

                <button v-if="isOwner" class="btn btn-light btn-sm" @click="onEditClick" data-bs-toggle="tooltip" data-placement="top" data-bs-title="edit theme">
                    <i class="fas fa-pencil text-primary"></i>
                </button>

                <button class="btn btn-light btn-sm" @click="onCopyClick" data-bs-toggle="tooltip" data-placement="top" data-bs-title="copy page">
                    <i class="fas fa-copy text-primary"></i>
                </button>

                <button v-if="isOwner" class="btn btn-light btn-sm" @click="confirmDelete = true" data-bs-toggle="tooltip" data-placement="top" data-bs-title="delete theme">
                    <i class="fas fa-trash-alt text-primary"></i>
                </button>
            </div>

            <div v-if="confirmDelete" class="m-2">
                <div>Confirm Delete?</div>
                <button @click="onDeleteConfirmed" class="btn btn-danger btn-sm me-1">yes</button>
                <button @click="confirmDelete = false" class="btn btn-secondary btn-sm">no</button>
            </div>

            <div v-for="theme in model.themes" class="border p-2">
                <a @click.stop="onThemeSelected(theme)" :class="viewModel.theme.id === theme.id ? 'fw-bold' : ''"
                   href="javascript:void(0)">{{theme.name}}</a>
            </div>

        </div>

        <example-theme-content :theme="viewModel.theme"></example-theme-content>

    </div>
</template>

<script>
import ExampleThemeContent from "./ExampleThemeContent.vue";
import ThemeService from "../services/ThemeService";

export default {
    name: 'ThemeBrowser',
    components: {ExampleThemeContent},
    props: ['viewModel', 'currentThemeId'],
    data () {
        return {
            model: webase.model,
            confirmDelete: false
        }
    },
    computed: {
        isOwner() {
            return this.model.currentUser.id !== null && this.model.currentUser.id === this.viewModel.theme.user_id
        }
    },
    mounted () {
        if(this.currentThemeId) {
            this.viewModel.theme = this.model.themes.find(theme => theme.id === this.currentThemeId);
        }
        else {
            this.viewModel.theme = this.model.themes[0]
        }

        webase.utils.font.loadThemeFonts(this.viewModel.theme)
        webase.utils.ui.injectTempCss(`themes/${this.viewModel.theme.id}`)

        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
        const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
    },
    methods: {
        onThemeSelected(theme) {
            this.viewModel.theme = theme
            webase.utils.font.loadThemeFonts(this.viewModel.theme)
            webase.utils.ui.injectTempCss(`themes/${theme.id}`)
        },

        onNewClick() {
            this.$emit('newThemeEvent');
        },

        onEditClick() {
            this.$emit('editThemeEvent');
        },

        onCopyClick() {
            this.$emit('copyThemeEvent');
        },

        onDeleteConfirmed() {
            let service = new ThemeService();
            service.remove(this.viewModel.theme.id).then((response) => {
                this.confirmDelete = false
                this.loadThemes()
            }).catch((message) => {
                console.log('error deleting theme')
                console.log(message)
            })
        },

        loadThemes() {
            let themeService = new ThemeService()
            themeService.list().then((response) => {
                this.model.themes = response
                this.viewModel.theme = this.model.themes[0]
            }).catch((message) => {
                console.log('error loading themes')
                console.log(message)
            })
        }
    }
}
</script>

<style>

</style>
